<template>
  <v-app class="app-class"> <slot /> </v-app>
</template>
